import React from 'react';
import { useSearchStateLocation } from './hooks/useSearchStateLocation';
import IconCheckmarkCircle from '../ui/icons/IconCheckmarkCircle';
import useSearchSubmarkets from './hooks/useSearchSubmarkets';

/*
Reorganize filters by state so it can show labels
[
    {
        state: "Arizona (AZ)",
        filters: [
            {
                label: "Arizona > Phoenix Metro",
                ...
            },
        ]
    },
    {
        state: "Texas (TX)",
        filters: [
            {
                label: "Texas > Austin",
            },
            {
                label: "Texas > Dallas-Fort Worth",
            },
        ]
    }
]
*/
const SearchLocationMenu = ( props ) => {
	const { submarket: submarketInState, stateAsLocation, isError } = useSearchStateLocation();
	const { submarketsByState } = useSearchSubmarkets();
	const { onSelectState, onSelectSubmarket } = props;

	const handleChangeState = ( stateNew ) => {
		if ( onSelectState ) {
			onSelectState( stateNew );
		}
	};

	const handleChangeSubmarket = ( submarketNew, stateNew ) => {
		if ( onSelectSubmarket ) {
			onSelectSubmarket( submarketNew, stateNew );
		}
	};

	if ( ! submarketsByState ) {
		return null;
	}

	if ( isError ) {
		return <p>Cannot display locations at this time.</p>;
	}
	
	return (
		<div className="tw-max-h-[780px] md:tw-max-h-[510px] xl:tw-max-h-[500px] tw-flex tw-flex-col tw-flex-wrap">
			{submarketsByState.map( ( state, index ) => {
				const isStateAsLocationRefined = stateAsLocation.name === state.name;
				return (
					<ul key={state.slug} className="tw-pl-0 tw-list-none tw-pr-2">
						<li>
							<button
								type="button"
								aria-label={`Select ${ state.name }`}
								onClick={() => handleChangeState( state )}
								className={`hover:tw-bg-aloe tw-px-2 tw-w-full tw-font-bold tw-mb-2 tw-py-1 tw-text-base tw-text-slate lg:tw-text-charcoal tw-flex tw-items-center ${ isStateAsLocationRefined ? 'tw-bg-apple' : 'tw-bg-white' }`}
							>
								{isStateAsLocationRefined && (
									<span className="tw-mr-1 tw-pl-1">
										<IconCheckmarkCircle />
									</span>
								)}
								{state.name}
							</button>
						</li>
						<li>
							<ul className='tw-pl-0 tw-list-none tw-ml-0'>
								{state.submarkets.map( ( submarket ) => {
									const submarketIsRefined = submarketInState.submarket === submarket.name && submarketInState.state === state.name;
									return (
										<li className='mb-2' key={submarket.name}>
											<div>
												<label className={`hover:tw-bg-aloe tw-font-medium tw-px-2 tw-py-1 tw-w-full tw-cursor-pointer tw-text-sm tw-text-charcoal tw-flex tw-items-center ${ submarketIsRefined ? 'tw-bg-apple' : 'tw-bg-white' }`}>
													{submarketIsRefined && (
														<span className="tw-mr-1">
															<IconCheckmarkCircle />
														</span>
													)}
													{submarket.name}
													<input className="tw-hidden" type="checkbox" checked={false} onChange={() => handleChangeSubmarket( submarket, state )} />
												</label>
											</div>
										</li>
									);
								} )}
							</ul>
						</li>
					</ul>
				);
			} )}
		</div>
	);
};

export default SearchLocationMenu;
